import {forwardRef} from 'react';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import {func, node, oneOfType} from 'prop-types';

import {BREAKPOINTS, MODULES_SIDEBAR_WIDTH} from '../../../const';
import useBreakpoint from '../../../hooks/dom/useBreakpoint';
import useMainSidebar from '../../../hooks/providers/useMainSidebar';

const ReportModulesSidebarContainer = forwardRef(({children}, ref) => {
  const breakpoint = useBreakpoint();

  const {isReportAndModulesMobileDrawerOpen: isOpen, setIsReportAndModulesMobileDrawerOpen: setIsOpen} = useMainSidebar();
  const commonStyles = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: MODULES_SIDEBAR_WIDTH,
    // Using DVH here because 100vh viewports on some mobile devices does not match a full height screen.
    // See : https://github.com/tailwindlabs/tailwindcss/discussions/4515 and https://web.dev/blog/viewport-units
    height: 'calc(100dvh - 64px)'
  };

  if (breakpoint === BREAKPOINTS.xs) {
    return (
      <Drawer
        role="presentation"
        ref={ref}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: {
            overflow: 'visible',
            marginTop: '64px',
            ...commonStyles
          }
        }}
      >
        {children}
      </Drawer>
    );
  }
  return (
    <Box
      ref={ref}
      sx={{
        ...commonStyles,
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        background: '#F6F6F6',
        zIndex: 99,
        position: 'sticky',
        top: 64
      }}
    >
      {children}
    </Box>
  );
});

ReportModulesSidebarContainer.propTypes = {
  children: oneOfType([node, func]).isRequired
};

export default ReportModulesSidebarContainer;
